<template>
    <core-basic-drop-down
        style="height: 34px"
        v-if="countries.length"
        :items="countries"
        :selection.sync="selected"
        forceFirstOption
        noneLabel="Land"
    ></core-basic-drop-down>
</template>

<script>
export default {
  data () {
    return {
      countries: this.$store.getters.countries,
      selected: this.selectedValue
    }
  },
  props: {
    selectedValue: {
      default: null,
      type: String | Number,
      required: false
    }
  },
  watch: {
    selected (val) {
      this.$emit('update:selectedValue', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Country.vue